import { InputPinCode, InputText } from 'components';
import { firebaseAuth } from 'configs/firebase';
import {
  PhoneAuthProvider,
  RecaptchaVerifier,
  signInWithCredential,
  signInWithPhoneNumber,
} from 'firebase/auth';
import { Button, InputWraper, useForm } from 'modules';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthRouteKeys } from 'routes/enums';
import { formatPhoneNumber } from 'utils/helpers/phoneNumber';
import { formSchemaOTP, formSchemaPN } from './config';
import { DEFAULT_COUNTDOWN_OTP } from 'configs';
import {
  useAuthControllerSendOtpByEmail,
  useAuthControllerVerifyOtpByEmail,
  useCheckPhoneNoQuery,
  useOtpPinSendOtp,
  useOtpPinVerifyOtp,
} from 'services';

type Props = {
  onChangeCallback?: (value: boolean) => void;
};

export enum TYPE_VERIFY {
  PHONE = 'phone',
  EMAIL = 'email',
}

const GetOTP = (props: Props): JSX.Element => {
  const { onChangeCallback } = props;

  const { mutateAsync: mutateAsyncSendOtpByEmail } =
    useAuthControllerSendOtpByEmail();
  const { mutateAsync: mutateAsyncVerifyOtpByEmail } =
    useAuthControllerVerifyOtpByEmail();

  const { mutateAsync: mutateAsyncSendOtp, isLoading: isLoadingSendOtp } =
    useOtpPinSendOtp();
  const { mutateAsync: mutateAsyncVerifyOtp, isLoading: isLoadingVerifyOtp } =
    useOtpPinVerifyOtp();
  void mutateAsyncSendOtp;
  void mutateAsyncVerifyOtp;

  // Cloudflare Turnstile + OTP Pin API captcha flow (commented out — Firebase OTP is restored)
  // const turnstileWidgetIdRef = useRef<string | undefined>(undefined);
  // const turnstileContainerRef = useRef<HTMLDivElement | null>(null);
  // const [captchaToken, setCaptchaToken] = useState<string>('');

  // useEffect(() => {
  //   const siteKey = getEnv('CF_TURNSTILE_SITE_KEY') || '';
  //   const scriptId = 'cf-turnstile-script';
  //   let isActive = true;
  //   let script: HTMLScriptElement | null = null;

  //   const renderWidget = () => {
  //     if (
  //       isActive &&
  //       window.turnstile &&
  //       turnstileContainerRef.current &&
  //       !turnstileWidgetIdRef.current
  //     ) {
  //       turnstileWidgetIdRef.current = window.turnstile.render(
  //         turnstileContainerRef.current,
  //         {
  //           sitekey: siteKey,
  //           callback: (token: string) => {
  //             if (isActive) setCaptchaToken(token);
  //           },
  //           'expired-callback': () => {
  //             if (isActive) setCaptchaToken('');
  //           },
  //           'error-callback': () => {
  //             if (isActive) setCaptchaToken('');
  //           },
  //         },
  //       );
  //     }
  //   };

  //   script = document.getElementById(scriptId) as HTMLScriptElement | null;

  //   if (!script) {
  //     script = document.createElement('script');
  //     script.id = scriptId;
  //     script.src =
  //       'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  //     script.async = true;
  //     script.defer = true;
  //     script.addEventListener('load', renderWidget);
  //     document.head.appendChild(script);
  //   } else if (window.turnstile) {
  //     renderWidget();
  //   } else {
  //     script.addEventListener('load', renderWidget);
  //   }

  //   return () => {
  //     isActive = false;
  //     script?.removeEventListener('load', renderWidget);
  //     if (turnstileWidgetIdRef.current && window.turnstile) {
  //       window.turnstile.remove(turnstileWidgetIdRef.current);
  //       turnstileWidgetIdRef.current = undefined;
  //     }
  //   };
  // }, []);

  useEffect(() => {
    window.recaptchaVerifier = new RecaptchaVerifier(
      'recaptcha-container',
      { size: 'invisible' },
      firebaseAuth,
    );
  }, []);

  const navigate = useNavigate();

  //
  const location = useLocation();

  const defaultPhoneNo = location.state?.phoneNumber || '';

  const initTypeVerify = location.state?.initTypeVerify || TYPE_VERIFY.PHONE;
  const onlyAllowPhone = location.state?.onlyAllowPhone || false;

  const [methodVerify, setMethoVerify] = useState<TYPE_VERIFY>(initTypeVerify);
  const [onlyAllowPhoneNo, setOnlyAllowPhoneNo] =
    useState<boolean>(onlyAllowPhone);
  const [phoneNumber, setPhoneNumber] = useState<string>(defaultPhoneNo);
  const {
    data,
    isFetching: isFetchingCheckPhoneNoQuery,
    refetch,
  } = useCheckPhoneNoQuery({
    phoneNumber,
  });
  //

  const [verificationId, setVerificationId] = useState<string>('');

  const [changeMethodVerify, setChangeMethodVerify] = useState<boolean>(false);

  const [countdown, setCountdown] = useState<number>(DEFAULT_COUNTDOWN_OTP);

  useEffect(() => {
    if (phoneNumber && phoneNumber.length >= 10) {
      refetch();
    }
  }, [phoneNumber]);

  useEffect(() => {
    if (countdown > 0) {
      const timerId = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);

      return () => clearTimeout(timerId);
    }
  }, [countdown]);

  useEffect(() => {
    if (!changeMethodVerify) return;
    handleResendOTP();
    setChangeMethodVerify(false);
  }, [changeMethodVerify, methodVerify]);

  useEffect(() => {
    if (!data) return;
    if (data && data.statusCode === 201) {
      setOnlyAllowPhoneNo(true);
      setMethoVerify(TYPE_VERIFY.PHONE);
    } else {
      setOnlyAllowPhoneNo(false);
      setMethoVerify(TYPE_VERIFY.EMAIL);
    }
  }, [data]);

  const handelChangePhoneNumber = () => {
    navigate(AuthRouteKeys.Login);
  };

  const handleVerifyPhoneNumber = async () => {
    var phoneNumber = getPhoneNumber('phoneNumber');
    if (!phoneNumber.value && !defaultPhoneNo) {
      toast.error('Vui lòng nhập số điện thoại');
    }

    const phone = formatPhoneNumber(defaultPhoneNo || phoneNumber.value);

    if (methodVerify === TYPE_VERIFY.PHONE) {
      try {
        const appVerifier = window.recaptchaVerifier;
        const confirmationResult = await signInWithPhoneNumber(
          firebaseAuth,
          phone,
          appVerifier as RecaptchaVerifier,
        );
        setVerificationId(confirmationResult.verificationId);
        toast.success('Gửi mã xác thực thành công');
      } catch (error: unknown) {
        toast.error(
          (error as Error)?.message ||
            'Đã có lỗi xảy ra, vui lòng thử lại sau.',
        );
      }

      // OTP Pin API — send OTP (commented out — Firebase OTP is restored)
      // try {
      //   if (!captchaToken) {
      //     toast.error('Vui lòng hoàn thành xác minh captcha');
      //     if (turnstileWidgetIdRef.current && window.turnstile) {
      //       window.turnstile.reset(turnstileWidgetIdRef.current);
      //     }
      //     return;
      //   }
      //   const res = await mutateAsyncSendOtp({
      //     phone,
      //     captcha_token: captchaToken,
      //   });
      //   setCountdown(res.expires_in || DEFAULT_COUNTDOWN_OTP);
      //   setVerificationId(phone);
      //   setCaptchaToken('');
      //   if (turnstileWidgetIdRef.current && window.turnstile) {
      //     window.turnstile.reset(turnstileWidgetIdRef.current);
      //   }
      //   toast.success('Gửi mã xác thực thành công');
      // } catch (error: unknown) {
      //   toast.error(
      //     (error as Error)?.message ||
      //       'Đã có lỗi xảy ra, vui lòng thử lại sau.',
      //   );
      //   setCaptchaToken('');
      //   if (turnstileWidgetIdRef.current && window.turnstile) {
      //     window.turnstile.reset(turnstileWidgetIdRef.current);
      //   }
      // }
    } else {
      const res = await mutateAsyncSendOtpByEmail({
        phoneNumber: phone,
      });
      setVerificationId(res.email);
      toast.success('Gửi mã xác thực thành công');
    }
  };

  const handleResendOTP = () => {
    if (methodVerify == TYPE_VERIFY.PHONE) {
      setCountdown(DEFAULT_COUNTDOWN_OTP);
      handleVerifyPhoneNumber();
    } else if (methodVerify == TYPE_VERIFY.EMAIL) {
      setCountdown(DEFAULT_COUNTDOWN_OTP);
      handleVerifyPhoneNumber();
    }
  };

  const handleSubmitOTP = async ({ otp }: { otp: string }) => {
    if (methodVerify == TYPE_VERIFY.PHONE) {
      try {
        var phoneNumber = getPhoneNumber('phoneNumber');
        const phone = formatPhoneNumber(defaultPhoneNo || phoneNumber.value);
        void phone;

        const credential = PhoneAuthProvider.credential(verificationId, otp);
        await signInWithCredential(firebaseAuth, credential);

        onChangeCallback?.(true);
        toast.success('Xác thực thành công');
        navigate(AuthRouteKeys.NewPassword);

        // OTP Pin API — verify OTP (commented out — Firebase OTP is restored)
        // const res = await mutateAsyncVerifyOtp({ phone, otp });
        // onChangeCallback?.(true);
        // toast.success('Xác thực thành công');
        // navigate(AuthRouteKeys.NewPassword, {
        //   state: { verify_token: res.verify_token },
        // });
      } catch (error) {
        toast.error('Mã xác thực không hợp lệ. Vui lòng thử lại.');
      }
    } else if (methodVerify == TYPE_VERIFY.EMAIL) {
      try {
        var phoneNumber = getPhoneNumber('phoneNumber');
        const res = await mutateAsyncVerifyOtpByEmail({
          phoneNumber: formatPhoneNumber(defaultPhoneNo || phoneNumber.value),
          otp,
        });
        onChangeCallback?.(true);
        toast.success('Xác thực thành công');
        navigate(AuthRouteKeys.NewPasswordVerifByEmail, {
          state: { token: res.token },
        });
      } catch (error) {
        // toast.error("Mã xác thực không hợp lệ. Vui lòng thử lại.");
      }
    }
  };

  const {
    handleSubmit: onSubmitFN,
    getInputProps: getPhoneNumber,
    isSubmitting: isSubmitPN,
  } = useForm({
    structure: formSchemaPN(defaultPhoneNo),
    onSubmit: handleVerifyPhoneNumber,
  });

  const {
    handleSubmit: onSubmitOtp,
    getInputProps: getOtp,
    isSubmitting: isSubmitOTP,
  } = useForm({
    structure: formSchemaOTP,
    onSubmit: handleSubmitOTP,
  });

  // const isPhoneVerification = methodVerify === TYPE_VERIFY.PHONE;
  // const isTurnstileRequired =
  //   isPhoneVerification && (!verificationId || countdown <= 0);
  // const isSendOtpDisabled = isPhoneVerification && !captchaToken;
  // const isResendOtpDisabled =
  //   countdown > 0 || (isPhoneVerification && !captchaToken);

  return (
    <>
      <div className='login-form'>
        <div className='login-form__logo'>
          <img
            style={{ width: '288px' }}
            className='login-form__logo__img'
            src='/assets/images/logo-white.png'
            alt=''
          />
        </div>

        <form onSubmit={onSubmitFN}>
          <InputWraper
            label={
              defaultPhoneNo ? 'Xác nhận số điện thoại' : 'Nhập số điện thoại'
            }
            inputProps={getPhoneNumber('phoneNumber')}
            onChangeCallback={setPhoneNumber}
            renderInput={(props) => {
              return <InputText {...props} isReadOnly={!!defaultPhoneNo} />;
            }}
          />

          {!verificationId && (
            <div className='login-form__actions'>
              <Button
                label='Gửi mã xác thực'
                type='submit'
                isLoading={
                  isSubmitPN || isFetchingCheckPhoneNoQuery || isLoadingSendOtp
                }
                // disabled={isSendOtpDisabled}
              />
              <Button
                label='Đổi tài khoản'
                type='button'
                onClick={handelChangePhoneNumber}
                buttonType='primary-outline'
              />
            </div>
          )}
        </form>

        {verificationId && (
          <form onSubmit={onSubmitOtp}>
            <InputWraper
              label={'OTP'}
              inputProps={{
                ...getOtp('otp'),
                inputMode: 'numeric',
                pattern: '[0-9]*',
              }}
              component={InputPinCode}
            />
            {verificationId && (
              <div className='textCenter text-verify'>
                OTP đã được gửi tới{' '}
                {methodVerify == TYPE_VERIFY.EMAIL
                  ? ` Email: ${verificationId}`
                  : ` SĐT: ${getPhoneNumber('phoneNumber').value}`}
              </div>
            )}
            <div className='login-form__actions'>
              <Button
                label='Xác nhận'
                type='submit'
                buttonType='success'
                isLoading={isSubmitOTP || isLoadingVerifyOtp}
              />

              <Button
                label={
                  countdown > 0 ? `Gửi lại mã sau ${countdown}s` : 'Gửi lại mã'
                }
                disabled={countdown > 0}
                onClick={handleResendOTP}
                type='button'
                buttonType='info-outline'
                isLoading={isSubmitPN}
              />
            </div>

            {!onlyAllowPhoneNo && (
              <div className='textCenter'>
                <Button
                  label={
                    'Xác thực OTP bằng ' +
                    (methodVerify == TYPE_VERIFY.EMAIL
                      ? 'Số điện thoại'
                      : 'Email')
                  }
                  type='button'
                  onClick={() => {
                    if (methodVerify == TYPE_VERIFY.EMAIL) {
                      setMethoVerify(TYPE_VERIFY.PHONE);
                    } else if (methodVerify == TYPE_VERIFY.PHONE) {
                      setMethoVerify(TYPE_VERIFY.EMAIL);
                    }
                    setChangeMethodVerify(true);
                  }}
                  buttonType='primary-outline'
                />
              </div>
            )}
            <div className='textCenter'>
              <Button
                label='Đổi tài khoản'
                type='button'
                onClick={handelChangePhoneNumber}
                buttonType='primary-outline'
              />
            </div>
          </form>
        )}

        {/* OTP Pin API Turnstile container (commented out — Firebase OTP is restored) */}
        {/* <div
          id='otp_send'
          ref={turnstileContainerRef}
          className='login-form__turnstile'
          style={{ display: isTurnstileRequired ? undefined : 'none' }}
        /> */}
      </div>

      <div id={`recaptcha-container`} />
    </>
  );
};

export default GetOTP;
